export default {
  themeColor: (state) => state.themeColor,
  locale: (state) => state.locale,
  notificationCount: (state) => state.notificationCount
}
